export * from "/codebuild/output/src808207952/src/dgbet/local_modules/wallet/index.ts"